import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { ShowToast } from "./state/common.actions";

@Injectable({ providedIn: 'root' })
export class AppFacade {
    constructor(private store: Store) {

    }

    showSuccessModal(title: any, message?: string) {
        return this.store.dispatch(new ShowToast('success', title, message));
    }


    showErrorModal(title: any, message?: string) {
        return this.store.dispatch(new ShowToast('error', title, message));
    }
}